module.exports = __webpack_public_path__ + "static/media/katy-perry-win.c63024ee.jpg";